import { render } from "./Slider.vue?vue&type=template&id=3780e4a4&scoped=true"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"

import "./Slider.vue?vue&type=style&index=0&id=3780e4a4&scoped=true&lang=css"

import exportComponent from "F:\\PROJECTS\\2022\\shop2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3780e4a4"]])

export default __exports__